import React from 'react'
import { Feed, Divider, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import Labels from './../../../../../common/Labels'
import momentDateAndTime from './../../../../../../helpers/momentDateAndTime'
import MomentTime from '../../../../../common/MomentTime';
import ImageAvater from '../../../../../drive/Components/ImageAvater';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})


class IssueLogsCard extends React.Component {
    render() {

        return (
            <Feed className={`issueMessage  `} >
                <Feed.Event className="pad_5">

                    <Feed.Content>
                        <Feed.Summary className="clr-blue">
                            {this.props.item.phase} <Icon name="chevron right" />
                            {this.props.item.stage && this.props.item.stage} {this.props.item.stage && <Icon name="chevron right" />}
                            {this.props.item.activityName}
                            <span className="pull-right"> <Icon className="clr-red" name="exclamation triangle" /></span>
                        </Feed.Summary>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_0" />
                <Feed.Event className="pad_5">
                    <ImageAvater user={this.props.item.data && this.props.item.data.accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.item.data && this.props.item.data.accountUserId.firstName + ' ' + this.props.item.data.accountUserId.lastName}
                            <span className="pull-right">{momentDateAndTime(this.props.item.data.createdDate)} </span>
                        </Feed.Summary>
                        <Feed.Date>
                            <span>resolved the issue</span>
                            <span className="pull-right" style={{ textAlign: "right" }}>
                                <MomentTime date={this.props.item.data.createdDate} /> </span></Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_lr_3" />
                <div className="pad_5">
                    <Labels
                        name="Why this is an issue?"
                        text={this.props.item.data.resolveComment ? this.props.item.data.resolveComment : 'None'}
                        htmlView={true}
                        className="bg-white" />
                </div>
                <div className="stratchSeprator"></div>
                <Feed.Event className="pad_5">
                    <ImageAvater user={this.props.item.data && this.props.item.data.accountUserId} />
                    <Feed.Content>
                        <Feed.Summary>
                            {this.props.item.data && this.props.item.data.accountUserId.firstName + ' ' + this.props.item.data.accountUserId.lastName}
                            <span className="pull-right">{momentDateAndTime(this.props.item.data.createdDate)} </span>
                        </Feed.Summary>
                        <Feed.Date>
                            <span>Created an issue</span>
                            <span className="pull-right" style={{ textAlign: "right" }}>
                                <MomentTime date={this.props.item.data.createdDate} /> </span></Feed.Date>
                    </Feed.Content>
                </Feed.Event>
                <Divider className="mar_lr_3" />
                <div className="pad_5">
                    <Labels
                        name="Why this is an issue?"
                        text={this.props.item.data.issue}
                        htmlView={true}
                        className="bg-white" />
                    <Labels
                        name="Why this is an issue?"
                        text={this.props.item.data.recommendedActions ? this.props.item.data.recommendedActions : 'None'}
                        htmlView={true}
                        className="bg-white" />
                </div>
            </Feed>
        )
    }
}

export default IssueLogsCard